import type { StepTask } from '../../types'
import { Field, ReadonlyValue, SectionHeader, getParams } from './fields'
import { KybProposedConfig } from './KybProposedConfig'

export interface KybDrawerProps {
  task: StepTask
  onChange: (updater: (t: StepTask) => StepTask) => void
}

export function KybDrawer({ task }: KybDrawerProps) {
  const params = getParams(task)
  const provider = (params.providerName as string | undefined) ?? ''
  const profileName = (params.name as string | undefined) ?? ''

  return (
    <div className="flex flex-col gap-4">
      <SectionHeader title="Existing ops center workflow config" />

      <Field label="Profile Name">
        <ReadonlyValue>{profileName || '—'}</ReadonlyValue>
      </Field>
      <Field label="Provider Name">
        <ReadonlyValue>{provider || '—'}</ReadonlyValue>
      </Field>

      <SectionHeader title="Proposed additional config" hint="Mockup · not saved" />
      <p className="text-[10px] text-[#5b6b85] -mt-2">
        Grouped by the v2 config file each setting lives in.
      </p>

      <KybProposedConfig />
    </div>
  )
}
